export interface ExtendedReportPayload {
  report: string;
  range: string[];
  comment: string;
  email?: string;
}

export enum ExtendedReportTypes {
  SEND_REQUEST = "@ExtendedReport/SEND_REQUEST",
  SEND_SUCCESS = "@ExtendedReport/SEND_SUCCESS",
  SEND_FAILURE = "@ExtendedReport/SEND_FAILURE",
}
